import PropTypes from 'prop-types';
import { Icon } from '@bwoty-web/ui-kit';
import { getMonth } from 'date-fns';
import {
  WEATHER_MOON,
  WEATHER_MOSTLY_CLOUDY,
  WEATHER_SUN,
} from '@bwoty-web/ui-kit/icons';

import { getMonthName } from '../../utils/date';
import { isCountry } from '../../utils/geoTypeUtils';

import './weatherOverlay.scss';

const WeatherOverlay = ({
  climateInLabel,
  itemName = null,
  itemType,
  siteId,
  temperature = null,
}) => {
  const day = temperature?.day || [];
  const night = temperature?.night || [];
  const monthNumber = getMonth(new Date());
  const renderDegrees = (value, classes) => {
    if (value === undefined || value === null) {
      return <span className="gw-weather-overlay__fallback">-</span>;
    }
    return (
      <>
        {value}
        <span className={classes}>°</span>
      </>
    );
  };

  const overlayContent = () => {
    if (isCountry(itemType)) {
      return (
        <div>
          <span className="gw-weather-overlay__title">
            {isCountry(itemType)
              ? `${climateInLabel} ${itemName}`
              : `${climateInLabel} ${getMonthName(monthNumber, siteId)}`}
          </span>
          <Icon
            alt="Weather icon"
            className="gw-weather-overlay__icon"
            path={WEATHER_MOSTLY_CLOUDY}
            size="xl"
          />
        </div>
      );
    }

    return (
      <div>
        <span className="gw-weather-overlay__title">
          {isCountry(itemType)
            ? `${climateInLabel} ${itemName}`
            : `${climateInLabel} ${getMonthName(monthNumber, siteId)}`}
        </span>
        <span className="gw-weather-overlay__temperature">
          <span className="gw-weather-overlay__entry gw-weather-overlay__entry--day">
            <Icon
              alt="Sun icon"
              className="gw-weather-overlay__sun-icon"
              path={WEATHER_SUN}
              size="s"
              sizeMobile="s"
            />
            {renderDegrees(day[monthNumber], 'weather__temp__grade')}
          </span>
          <span className="gw-weather-overlay__entry gw-weather-overlay__entry--night">
            <Icon
              alt="Moon icon"
              className="gw-weather-overlay__night-icon"
              path={WEATHER_MOON}
              size="s"
              sizeMobile="s"
            />
            {renderDegrees(night[monthNumber], 'weather__temp__grade')}
          </span>
        </span>
        <span className="clear" />
      </div>
    );
  };

  return <div className="gw-weather-overlay">{overlayContent()}</div>;
};

WeatherOverlay.propTypes = {
  temperature: PropTypes.shape({
    day: PropTypes.arrayOf(PropTypes.number).isRequired,
    night: PropTypes.arrayOf(PropTypes.number).isRequired,
  }),
  siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  climateInLabel: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  itemName: PropTypes.string,
};

export default WeatherOverlay;
